export const EXIF_TAGS = [
  { tag: '-FDCOMP', description: 'Front Driver Compartment' },
  { tag: '-DASH', description: 'Dashboard' },
  { tag: '-CARGO-UP', description: 'Trunk/Cargo (Seats Up)' },
  { tag: '-E-R', description: 'Rear' },
];
